export default __webpack_public_path__ + "static/media/ourP1.4bbe352c.png";